import { Route, Routes } from "react-router-dom";

import { PaymentMethodsLink } from "../../pages";

export const PaymentMethodsLinkLayout = () => {
  return (
    <Routes>
      <Route path="/" element={<PaymentMethodsLink />} />
    </Routes>
  );
};
